import { BaseListFilter } from './base-list-filter.model';

export enum SvbPreparedFiltersEnum {
  SvbNotEligible = 0,
  SvbEligible = 1,
}

export class SvbListFilter extends BaseListFilter {
  preparedFilters?: SvbPreparedFiltersEnum;
}
